<div id="insights-scroll-container" #insightsScrollContainer class="insights-table-scroll-container" [class.has-scrollbar]="hasHorizontalScrollbar">
  <div class="insights-table-wrapper">
    @if (showLoadingView) {
      <div class="loading-overlay">
        <div class="centered-loader-container">
          <div class="loader centered-loader"></div>
        </div>
      </div>
    }
    <table #insightsTable class="insights-table">
      <thead>
        <tr class="insights-table-header">
          <th class="label-cell">
            <div class="label-cell-content">
              <div class="insights-close" (click)="handleCloseInsights()">
                <i class="fas fa-xmark clickable"></i>
              </div>
              <div class="item-label-text">
                {{ mainRow?.label }}
              </div>
            </div>
          </th>
          @for (column of activeDataView.columns; track column; let idx = $index) {
            @if (showHidden || !column.isHidden) {
              <th
                class="insights-header-cell"
                    [ngClass]="{
                    'no-padding': !mainRow.values?.[idx]?.formattedValue,
                    'excluded-from-calculations': mainRow.values?.[idx]?.isExcludedFromCalculations
                    }"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                [title]="mainRow?.values?.[idx]?.isExcludedFromCalculations ? excludedCellTooltipText : ''"
                >
                {{ mainRow.values?.[idx]?.formattedValue || "-" }}
              </th>
            }
            @if (showHidden || !column.isHidden) {
              @if (!column.trendIsHidden) {
                <th
                  class="insights-header-cell"
                  [ngClass]="{'no-padding': mainRow.values?.[idx]?.trendValue === undefined || mainRow.values?.[idx]?.trendValue === null}">
                  @if ((mainRow.values?.[idx]?.trendValue === undefined || mainRow.values?.[idx]?.trendValue === null)) {
                    <div>
                      -
                    </div>
                  } @else {
                    {{ mainRow.values?.[idx]?.formattedTrendValue }}%
                  }
                </th>
              }
              @if (!column.commonSizeIsHidden) {
                <th
                  class="insights-header-cell"
                  [ngClass]="{'no-padding': !mainRow.values?.[idx]?.commonSizedValue}">
                  {{ mainRow.values?.[idx]?.formattedCommonSizedValue || "-" }}
                </th>
              }
            }
          }
        </tr>
      </thead>
      <tbody class="insight-table-body">
        <ng-template #labelCell let-component="component">
          @if (component.symbolDisplayArray && component.symbolDisplayArray.length > 0) {
            @for (symbolDisplay of component.symbolDisplayArray; track symbolDisplay; let symbolIdx = $index; let isLast = $last) {
              @if (symbolDisplay.isIcon) {
                <div class="equation-symbol-icon-container"
                  [ngClass]="symbolDisplay.iconInfo?.customClass"
                  [style.background-color]="symbolDisplay.iconInfo.backgroundColor">
                  <i class="equation-symbol-icon fa" [ngClass]="symbolDisplay.iconInfo.iconName"
                    [style.color]="symbolDisplay.iconInfo.iconColor"
                  ></i>
                </div>
              } @else {
                <span [class.parenthesis-symbol]="symbolDisplay.symbol === '(' || symbolDisplay.symbol === ')'"
                  [class.parenthesis-highlighted]="((symbolDisplay.symbol === '(' && component.isOpeningParenthesis && symbolIdx === component.openingParenthesisSymbolIndex) || (symbolDisplay.symbol === ')' && component.isClosingParenthesis)) && component.isParenthesisSymbolHighlighted"
                  (mouseenter)="onSymbolMouseEnter(symbolDisplay.symbol, component, symbolIdx)"
                  (mouseleave)="onSymbolMouseLeave(symbolDisplay.symbol)">
                  {{ symbolDisplay.symbol }}
                </span>
              }
            }
            <div class="label-text">
              @if (component.isClosingParenthesis && component.baseLabel?.endsWith(' )')) {
                <div class="base-label-text">{{ component.baseLabel?.slice(0, -2) }}</div><span class="parenthesis-symbol parenthesis-closing-text"
                [class.parenthesis-highlighted]="component.isParenthesisSymbolHighlighted"
                (mouseenter)="onParenthesisHover(component.parenthesisPairId)"
              (mouseleave)="onParenthesisLeave()">)</span>
            } @else {
              {{ component.baseLabel }}
            }
          </div>
        } @else {
          <div class="label-text">{{ component.displayLabel }}</div>
        }
        @if (!component.isRaw && !component.isSymbol) {
          @if (component.loadingChildRows) {
            <i class="fas fa-circle-notch fa-spin child-row-loading-spinner"></i>
          } @else {
            @if (!component?.childRows?.length) {
              <i class="fas fa-chevron-down expand-icon clickable"></i>
            } @else {
              <i class="fas fa-chevron-up collapse-icon clickable"></i>
            }
          }
        }
        @if (component.isRaw) {
          <div class="source-item-label">
            Source Item
          </div>
        }
      </ng-template>

      <ng-template #valueCells let-component="component">
        @for (column of activeDataView.columns; track column; let idx = $index) {
          <td class="body-value-cell"
                    [ngClass]="{
                        'hidden': (!showHidden && column.isHidden), 
                        'no-padding': !component?.values?.[idx]?.formattedValue,
                        'excluded-from-calculations': component?.values?.[idx]?.isExcludedFromCalculations
                        }"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            [title]="component?.values?.[idx]?.isExcludedFromCalculations ? excludedCellTooltipText : ''"
            >
                    <div class="body-value-cell-container" [ngClass]="{
                        'icon-cell-alignment': component?.values?.[idx]?.sourceBox || component?.values?.[idx]?.footnotes?.length
                    }">
              @if (component?.values?.[idx]?.footnotes?.length) {
                <div class="btn-group dropup">
                  <i class="cell-value-dropdown-icon clickable fa fa-chevron-down"
                  data-bs-toggle="dropdown" aria-expanded="false"></i>
                  <ul class="dropdown-menu">
                    @if (component?.values?.[idx]?.sourceBox) {
                      <li class="dropdown-item">
                        <span (click)="clickOpenSourceBox(component.values[idx].sourceBox)">Show Source</span>
                      </li>
                    }
                    @for (footnote of component?.values?.[idx]?.footnotes; track footnote; let idx = $index) {
                      <li class="dropdown-item"
                        >
                        <span (click)="clickOpenSourceBox(footnote)">Show Footnote {{ idx + 1 }}</span>
                      </li>
                    }
                  </ul>
                </div>
              } @else {
                @if (component?.values?.[idx]?.sourceBox) {
                  <i title='Click to view this item in the source document'
                    (click)="clickOpenSourceBox(component?.values?.[idx]?.sourceBox)"
                  class="show-source-icon clickable fa fa-eye"></i>
                }
              }
              <div>
                {{ component?.values?.[idx]?.formattedValue || "-" }}
              </div>
            </div>
          </td>
          @if (showHidden || !column.isHidden) {
            @if (!column.trendIsHidden) {
              <td class="body-value-cell"
                [ngClass]="{'no-padding': component?.values?.[idx]?.trendValue === undefined || component?.values?.[idx]?.trendValue === null}">
                @if (component?.values?.[idx]?.trendValue > 0) {
                  <div class="trend-up-cell">
                    <i class="fa fa-caret-up trend-icon"></i>{{ component?.values?.[idx]?.formattedTrendValue }}%
                  </div>
                }
                @if (component?.values?.[idx]?.trendValue < 0) {
                  <div class="trend-down-cell">
                    <i class="fa fa-caret-down trend-icon"></i>{{ component?.values?.[idx]?.formattedTrendValue }}%
                  </div>
                }
                @if (component?.values?.[idx]?.trendValue === 0) {
                  <div class="trend-zero-cell">
                    0.0%
                  </div>
                }
                @if (component?.values?.[idx]?.trendValue === undefined || component?.values?.[idx]?.trendValue === null) {
                  <div>
                    -
                  </div>
                }
              </td>
            }
            @if (!column.commonSizeIsHidden) {
              <td class="body-value-cell"
                [ngClass]="{'no-padding': !component?.values?.[idx]?.commonSizedValue}">
                {{ component?.values?.[idx]?.formattedCommonSizedValue || "-" }}
              </td>
            }
          }
        }
      </ng-template>

      <ng-template #insightRow let-component="component" let-indentLevel="indentLevel">
        @if (component.isDivisionSeparator) {
          <tr class="division-separator-row">
            <td class="division-separator-cell" [attr.colspan]="totalVisibleColumnCount">
              <div class="division-separator-line"></div>
              <div class="division-separator-icon-container">
                <i class="fas fa-divide division-separator-icon"></i>
              </div>
            </td>
          </tr>
        } @else {
                <tr [ngClass]="{
                    'expanded-row-highlight' : component?.childRows?.length,
                    'child-row' : indentLevel > 0,
                    'numerator-row': component?.divisionGroup === 'numerator',
                    'denominator-row': component?.divisionGroup === 'denominator'
                    }"
            [attr.data-indent-level]="indentLevel"
            [attr.data-division-group]="component?.divisionGroup">
            <td class="body-label-cell"
              [class.parenthesis-box-opening]="component.isHighlightedOpening"
              [class.parenthesis-box-contained]="component.isHighlightedContained"
              [class.parenthesis-box-closing]="component.isHighlightedClosing"
              [class.parenthesis-box-child]="(component.isHighlightedOpening || component.isHighlightedContained || component.isHighlightedClosing) && indentLevel > 0"
              (click)="handleComponentLabelClick(component)">
              <ng-container *ngTemplateOutlet="labelCell; context: {component: component}"></ng-container>
            </td>
            <ng-container *ngTemplateOutlet="valueCells; context: {component: component}"></ng-container>
          </tr>
        }
        @if (component.childRows?.length) {
          @for (childComponent of component.childRows; track childComponent) {
            <ng-container *ngTemplateOutlet="insightRow; context: {component: childComponent, indentLevel: indentLevel + 1}">
            </ng-container>
          }
        }
      </ng-template>

      @for (component of insightRows; track component) {
        <ng-container
          *ngTemplateOutlet="insightRow; context: {component: component, indentLevel: 0}">
        </ng-container>
      }
    </tbody>
  </table>
</div>
</div>
